/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// react
import React, { forwardRef } from "react";
// material ui components
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Select from "@mui/material/Select";

const TemplateSelect = forwardRef((props, ref) => {
  const { templates, value, onChange, className, errors, handleTemplateChange } = props;
  const sortedTemplates = templates.sort((a, b) => a.label.localeCompare(b.label));

  const handleChange = (event) => {
    handleTemplateChange(event.target.value);
    // update the form
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth className={className} error={!!errors.template}>
      <InputLabel id="select-template">Templates</InputLabel>
      <Select
        labelId="select-template"
        id="template"
        value={value}
        label="Template"
        onChange={handleChange}
        ref={ref}
        classes={{ select: "flex items-center space-x-12" }}
        defaultValue=""
        size="small"
      >
        <MenuItem value="" disabled className="space-x-12">
          <span>Select a template</span>
        </MenuItem>
        {sortedTemplates.map((template) => (
          <MenuItem value={template.id} key={template.label} className="space-x-12">
            <span>{template.label} {template.title}</span>
          </MenuItem>
        ))}
      </Select>
      {!!errors.template ? (
        <FormHelperText>{errors?.template?.message}</FormHelperText>
      ) : null}
    </FormControl>
  );
});

export default TemplateSelect;
